export default {
      id: "i-file-usage",
      viewBox: "0 0 32 44",
      url: __webpack_public_path__ + "img/sprite.svg#i-file",
      toString: function () {
        return this.url;
      }
    }